import { Box, Portal } from "@mui/material";
import { Theme } from "@mui/material/styles";

import { AIChatModal } from "./aiChatModal";

type Props = {
  open: boolean;
  onClose: () => void;
};

export function AIChatWidget({ open, onClose }: Props) {
  if (!open) return null;

  return (
    <Portal>
      <Box
        sx={(theme: Theme) => ({
          zIndex: 1000,
          position: "fixed",
          top: 70,
          bottom: 10,
          right: 10,
          width: 600,

          [theme.breakpoints.down("md")]: {
            width: 360,
          },

          [theme.breakpoints.down("sm")]: {
            top: 60,
            bottom: 0,
            pb: 7,
            right: 0,
            left: 0,
            width: "100%",
            height: "100%",
          },
        })}
      >
        <AIChatModal onClose={onClose} />
      </Box>
    </Portal>
  );
}